import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

// بررسی می‌کند که رشته با data: شروع می‌شود (Data URL)
const isDataURL = (str) => /^data:/.test(str);

// بررسی می‌کند که رشته یک SVG است (با <svg شروع می‌شود)
const isSVGString = (str) => /^\s*<svg/.test(str);

// تشخیص نوع تصویر از روی base64 خام (بدون پیشوند data:)
function detectImageMimeTypeFromBase64(base64) {
  const clean = base64?.replace(/\s/g, '');
  // بررسی ابتدایی برای معتبر بودن base64
  if (!/^[A-Za-z0-9+/=]+$/.test(clean)) return null;

  try {
    // چند بایت اول را دیکد می‌کنیم
    const header = atob(clean.slice(0, 24));
    const bytes = new Uint8Array([...header].map(c => c.charCodeAt(0)));

    // PNG: 89 50 4E 47
    if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47)
      return 'image/png';
    // JPEG: FF D8 FF
    if (bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF)
      return 'image/jpeg';
    // GIF: 47 49 46 38
    if (bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x38)
      return 'image/gif';
    // WebP: RIFF....WEBP
    if (bytes[0] === 0x52 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x46) {
      if (bytes[8] === 0x57 && bytes[9] === 0x45 && bytes[10] === 0x42 && bytes[11] === 0x50)
        return 'image/webp';
    }
  } catch (e) {
    // رشته معتبر base64 نیست
  }
  return null;
}

/**
 * کامپوننت هوشمند نمایش QR Code
 * @param {string} data - داده‌ای که ممکن است متن، Data URL، SVG یا base64 باشد.
 * @param {number} size - اندازه نهایی QR Code (پیش‌فرض ۲۵۶)
 */
const SmartQRCode = ({ data, size = 90, ...props }) => {
  if (!data) return null;

  // ۱. اگر Data URL است، مستقیماً به عنوان تصویر نمایش بده
  if (isDataURL(data)) {
    return <img src={data} alt="QR Code" width={size} height={size} {...props} />;
  }

  // ۲. اگر رشته SVG است، به Data URL تبدیل کن و به عنوان تصویر نمایش بده
  if (isSVGString(data)) {
    const svgDataURL = `data:image/svg+xml;utf8,${encodeURIComponent(data)}`;
    return <img src={svgDataURL} alt="QR Code" width={size} height={size} {...props} />;
  }

  // ۳. اگر base64 خام است و نوع تصویر قابل تشخیص است، به Data URL تبدیل کن
  const mimeType = detectImageMimeTypeFromBase64(data);
  if (mimeType) {
    const dataURL = `data:${mimeType};base64,${data}`;
    return <img src={dataURL} alt="QR Code" width={size} height={size} {...props} />;
  }

  // ۴. در غیر این صورت، متن خام است و باید QR Code ساخته شود
  return <QRCodeSVG value={data} size={size} {...props} />;
};

export default SmartQRCode;
